import {Component, Inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA} from "@angular/material/snack-bar";

export class SnackbarMsg {
  public typeError: SnackbarTypeError;
  public menssage: string;

  constructor(typeError: SnackbarTypeError, menssage: string) {
    this.typeError = typeError;
    this.menssage = menssage;
  }
}

export enum SnackbarTypeError {
  INFO = 'INFO',
  WARN = 'WARNING',
  ERROR = 'ERROR'
}

@Component({
    selector: 'app-msg-snackbar',
    templateUrl: './msg-snackbar.component.html',
    styleUrls: ['./msg-snackbar.component.css'],
    standalone: false
})
export class MsgSnackbarComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: SnackbarMsg) { }
}


